(() => {
  'use strict';
  const t = (key, values = {}, fallback = key) => window.NLV?.i18n?.t(key, values, fallback) ?? String(fallback).replace(/\{([a-zA-Z_][\w]*)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
  if (window.NLVWarehouseBooking) { window.NLVWarehouseBooking.init(document); return; }
  const instances = new Map();
  const pad = number => String(number).padStart(2, '0');
  const isoDate = date => `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
  const parseDate = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(`${value}T12:00:00Z`);
    return Number.isFinite(date.getTime()) && isoDate(date) === value ? date : null;
  };
  const addDays = (value, amount) => { const date = parseDate(value); date.setUTCDate(date.getUTCDate() + amount); return isoDate(date); };
  const minutes = value => { const match = /^(\d{2}):(\d{2})$/.exec(value || ''); return match && Number(match[1]) < 24 && Number(match[2]) < 60 ? Number(match[1]) * 60 + Number(match[2]) : null; };
  const timeValue = value => `${pad(Math.floor(value / 60))}:${pad(value % 60)}`;
  const escape = value => String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  const init = scope => scope.querySelectorAll('[data-warehouse-booking]').forEach(element => {
    if (instances.has(element)) return;
    const form = element.querySelector('form');
    const dateInput = element.querySelector('[data-booking-date]');
    if (!form || !dateInput) {
      element.querySelector('[data-booking-response]')?.focus({ preventScroll: true });
      return;
    }
    const abort = new AbortController(), options = { signal: abort.signal };
    const calendar = element.querySelector('[data-booking-calendar]');
    const grid = element.querySelector('[data-booking-grid]');
    const days = element.querySelector('[data-booking-days]');
    const heading = element.querySelector('[data-booking-month]');
    const previous = element.querySelector('[data-booking-previous]');
    const next = element.querySelector('[data-booking-next]');
    const timeInput = element.querySelector('[data-booking-time]');
    const slots = element.querySelector('[data-booking-slots]');
    const zoneInput = element.querySelector('[data-booking-zone]');
    const zoneLabel = element.querySelector('[data-booking-timezone-label]');
    const zoneCopy = element.querySelector('[data-booking-timezone-copy]');
    const validation = element.querySelector('[data-booking-validation]');
    const summary = element.querySelector('[data-booking-summary]');
    const locale = document.documentElement.lang || 'en-US';
    const duration = Math.max(15, Math.min(180, Number(element.dataset.bookingDuration) || 60));
    const horizon = Math.max(1, Math.min(365, Number(element.dataset.bookingHorizon) || 90));
    let timezone = element.dataset.bookingTimezone?.trim() || '', validTimezone = false, schedule = {};
    try { if (timezone) { new Intl.DateTimeFormat('en-US', { timeZone: timezone }).format(); validTimezone = true; } } catch (_) {}
    try { schedule = JSON.parse(element.querySelector('[data-booking-schedule]').textContent); } catch (_) {}
    const hours = {};
    let malformedHours = false;
    Object.entries(schedule).forEach(([day, value]) => {
      if (!String(value || '').trim()) return;
      const match = /^\s*(\d{2}:\d{2})\s*[-–]\s*(\d{2}:\d{2})\s*$/.exec(value);
      const start = match ? minutes(match[1]) : null, end = match ? minutes(match[2]) : null;
      if (start === null || end === null || end - start < duration || !/^[0-6]$/.test(day)) { malformedHours = true; return; }
      hours[day] = [start, end];
    });
    const configured = element.dataset.bookingConfigured === 'true' && validTimezone && !malformedHours && Object.keys(hours).length > 0;
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (!configured) timezone = localTimezone;
    const current = () => {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { ...(timezone ? { timeZone: timezone } : {}), year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).map(part => [part.type, part.value]));
      return { date: `${parts.year}-${parts.month}-${parts.day}`, minute: Number(parts.hour) * 60 + Number(parts.minute) };
    };
    const today = current().date, firstDate = configured ? today : addDays(today, 1), lastDate = addDays(today, horizon);
    let month = firstDate.slice(0, 7), focusDay = firstDate;
    const longDate = value => new Intl.DateTimeFormat(locale, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(parseDate(value));
    const clock = minute => new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' }).format(new Date(`2000-01-01T${timeValue(minute)}:00Z`));
    const timesFor = value => {
      const date = parseDate(value), range = date && hours[date.getUTCDay()];
      if (!range) return [];
      const present = current(), times = [];
      for (let minute = range[0]; minute + duration <= range[1]; minute += duration) {
        if (value === present.date && minute <= present.minute) continue;
        times.push(minute);
      }
      return times;
    };
    const selectable = value => Boolean(parseDate(value) && value >= (configured ? current().date : addDays(current().date, 1)) && value <= lastDate && (!configured || timesFor(value).length));
    const message = text => { validation.textContent = text; validation.hidden = !text; };
    const selectedTime = () => configured ? slots.value : timeInput.value;
    const updateSummary = () => {
      if (!dateInput.value || !selectedTime() || !selectable(dateInput.value)) { summary.textContent = t('warehouse.select', {}, "Select a preferred date and time for your visit request."); return; }
      const chosen = minutes(selectedTime());
      summary.textContent = t('warehouse.visit_requested', { date: longDate(dateInput.value), time: chosen === null ? selectedTime() : clock(chosen), zone: zoneInput.value ? ` (${zoneInput.value})` : '' }, 'Visit requested for {date} at {time}{zone}. Our team will email to confirm.');
    };
    const updateTimes = () => {
      if (configured) {
        const old = slots.value, values = selectable(dateInput.value) ? timesFor(dateInput.value) : [];
        slots.innerHTML = `<option value="">${dateInput.value ? t('warehouse.choose_time', {}, "Choose a preferred time") : t('warehouse.choose_date', {}, "Choose a date first")}</option>` + values.map(minute => `<option value="${timeValue(minute)}">${escape(clock(minute))} – ${escape(clock(minute + duration))}</option>`).join('');
        slots.disabled = !dateInput.value;
        if (values.some(minute => timeValue(minute) === old)) slots.value = old;
      }
      updateSummary();
    };
    const render = (moveFocus = false) => {
      const first = parseDate(`${month}-01`), year = first.getUTCFullYear(), index = first.getUTCMonth();
      const count = new Date(Date.UTC(year, index + 1, 0)).getUTCDate(), offset = first.getUTCDay();
      heading.textContent = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(first);
      grid.setAttribute('aria-label', t('warehouse.grid_label', { month: heading.textContent }, '{month}: choose a preferred visit date'));
      const enabled = Array.from({ length: count }, (_, i) => `${month}-${pad(i + 1)}`).filter(selectable);
      if (!enabled.includes(focusDay)) focusDay = enabled.includes(dateInput.value) ? dateInput.value : enabled[0];
      let html = '';
      for (let cell = 0; cell < Math.ceil((offset + count) / 7) * 7; cell++) {
        if (cell % 7 === 0) html += '<tr>';
        const day = cell - offset + 1, value = `${month}-${pad(day)}`;
        html += day < 1 || day > count ? '<td aria-hidden="true"></td>' : `<td><button type="button" data-booking-day="${value}" aria-label="${escape(longDate(value))}" aria-pressed="${dateInput.value === value}"${value === today ? ' aria-current="date"' : ''} tabindex="${value === focusDay ? '0' : '-1'}"${selectable(value) ? '' : ' disabled'}>${day}</button></td>`;
        if (cell % 7 === 6) html += '</tr>';
      }
      days.innerHTML = html;
      previous.disabled = month <= firstDate.slice(0, 7);
      next.disabled = month >= lastDate.slice(0, 7);
      if (moveFocus && focusDay) days.querySelector(`[data-booking-day="${focusDay}"]`)?.focus({ preventScroll: true });
    };
    const choose = value => {
      dateInput.value = value;
      const error = value && !selectable(value) ? configured ? t('warehouse.hours_error', {}, "Choose a date during our visiting hours within the request window.") : t('warehouse.date_error', {}, "Choose a date from tomorrow onward within the request window.") : '';
      dateInput.setCustomValidity(error);
      message(error);
      if (parseDate(value) && value >= firstDate && value <= lastDate) { month = value.slice(0, 7); focusDay = value; }
      updateTimes(); render();
    };
    const changeMonth = amount => {
      const date = parseDate(`${month}-01`); date.setUTCMonth(date.getUTCMonth() + amount);
      const candidate = isoDate(date).slice(0, 7);
      if (candidate < firstDate.slice(0, 7) || candidate > lastDate.slice(0, 7)) return;
      month = candidate; render();
    };
    dateInput.min = firstDate; dateInput.max = lastDate;
    if (configured) {
      timeInput.disabled = true; timeInput.hidden = true; timeInput.required = false; slots.hidden = false;
      element.querySelector('[data-booking-time-label]').htmlFor = slots.id;
      element.querySelector('[data-booking-time-label]').textContent = t('warehouse.preferred_time', {}, "Preferred visit time");
      zoneInput.value = timezone; zoneInput.readOnly = true; zoneLabel.textContent = t('warehouse.zone', {}, "Warehouse time zone");
      zoneCopy.textContent = t('warehouse.duration_note', { duration, zone: timezone }, '{duration}-minute visits. Times follow {zone}. All visit requests need confirmation.');
      element.querySelector('[data-booking-calendar-note]').textContent = t('warehouse.dates_note', {}, "Dates follow our visiting hours. A selected day is a request, subject to confirmation.");
    } else {
      zoneInput.value = localTimezone;
      element.querySelector('[data-booking-time-label]').textContent = t('warehouse.local_time', {}, "Preferred time in your time zone");
      zoneCopy.textContent = t('warehouse.local_note', {}, "Request a visit from tomorrow onward in your local time. Our team will confirm the warehouse time and visiting hours.");
      element.querySelector('[data-booking-calendar-note]').textContent = t('warehouse.unconfigured_note', {}, "Choose a preferred date from tomorrow onward. Each visit needs confirmation from our team.");
    }
    previous.addEventListener('click', () => changeMonth(-1), options);
    next.addEventListener('click', () => changeMonth(1), options);
    days.addEventListener('click', event => {
      const button = event.target.closest?.('[data-booking-day]');
      if (!button || button.disabled) return;
      choose(button.dataset.bookingDay); days.querySelector(`[data-booking-day="${dateInput.value}"]`)?.focus({ preventScroll: true });
    }, options);
    days.addEventListener('keydown', event => {
      const button = event.target.closest?.('[data-booking-day]');
      if (!button) return;
      let amount = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[event.key];
      if (amount === undefined) return;
      event.preventDefault();
      let candidate = addDays(button.dataset.bookingDay, amount);
      for (let tries = 0; tries <= horizon; tries++) {
        if (candidate < firstDate || candidate > lastDate) return;
        if (selectable(candidate)) { focusDay = candidate; month = candidate.slice(0, 7); render(true); return; }
        candidate = addDays(candidate, amount < 0 ? -1 : 1);
      }
    }, options);
    dateInput.addEventListener('change', () => choose(dateInput.value), options);
    [timeInput, slots, zoneInput].forEach(input => input.addEventListener('input', updateSummary, options));
    form.addEventListener('submit', event => {
      choose(dateInput.value);
      const selected = minutes(selectedTime());
      if (!selectable(dateInput.value) || selected === null || (configured && !timesFor(dateInput.value).includes(selected))) {
        event.preventDefault(); message(t('warehouse.validation', {}, "Choose a valid preferred date and time before sending your visit request.")); validation.focus?.(); return;
      }
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
    }, options);
    calendar.hidden = false;
    updateTimes(); render();
    instances.set(element, { dispose: () => { abort.abort(); instances.delete(element); } });
  });
  window.NLVWarehouseBooking = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-warehouse-booking]').forEach(element => instances.get(element)?.dispose()));
})();
